import { Database } from '@nozbe/watermelondb'
import { ComponentInfoChatVO } from '@repo/types'
import { findChatByConnectionKeyAndPhoneNumber } from '../readers'

export const archiveChat = async (payload: ComponentInfoChatVO, database: Database) => {
  const { connectionKey, phoneNumber } = payload

  const chat = await findChatByConnectionKeyAndPhoneNumber(connectionKey, phoneNumber, database)

  if (chat) {
    await database.write(async () => {
      await chat.update(it => it.markAsArchived(payload))
    })
  }
}
